import { Link } from 'react-router-dom';
import { categories, contactInfo } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl font-bold text-white">天堂影院</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              免费在线看大片，高清流畅不缓冲。涵盖电影、电视剧、综艺、动漫等多种类型，为您提供最优质的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              <a href="#categories" className="cursor-pointer">影视分类</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              <a href="#quick-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">网站首页</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">最新电影</Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">热播电视剧</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              <a href="#contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i>
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line"></i>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line"></i>
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 天堂影院 tiantangcinema.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}